export type ModuleChild = {
  id?: string;
  name: string;
  onClick?: () => void;
  path?: string;
  children?: ModuleChild[];
};

export type Module = {
  id?: string;
  name: string;
  icon: React.ElementType;
  path: string;
  alignment?: string;
  secondaryPaths?: string[];
  children?: ModuleChild[];
  // A component, not a number: the nav copies modules into state, so a value would go stale.
  badge?: React.ComponentType<{ collapsed: boolean }>;
};

export const MODULE_IDS = {
  CHECKS: 'CHECKS',
  TRANSACTIONS: 'TRANSACTIONS',
  COMPLIANCE_TRANSACTIONS: 'COMPLIANCE_TRANSACTIONS',
  EARNESTLY: 'EARNESTLY',
  COMPLIANCE_REPORTING: 'COMPLIANCE_REPORTING',
  COMPLIANCE_REPORTS: 'COMPLIANCE_REPORTS',
  COMPLIANCE_REPORTING_CONFIG: 'COMPLIANCE_REPORTING_CONFIG',

  DAILY_HUB: 'DAILY_HUB',
  DAILY_HUB_ADMIN_HUB: 'DAILY_HUB_ADMIN_HUB',
  DAILY_HUB_TEAM_HUB: 'DAILY_HUB_TEAM_HUB',
  DAILY_HUB_MY_HUB: 'DAILY_HUB_MY_HUB',

  OFFICES_AND_TEAMS: 'OFFICES_AND_TEAMS',
  TASKS: 'TASKS',
  EFTS: 'EFTS',
  TASK_TEMPLATES: 'TASK_TEMPLATES',
  DOCUMENT_RULES: 'DOCUMENT_RULES',
  SUPPORT: 'SUPPORT',
  // Distinct from SUPPORT, which is the internal document-triage module.
  HELP: 'HELP',
  FORMS_LIBRARY: 'FORMS_LIBRARY',
  PARTNER_LOOPS: 'PARTNER_LOOPS',
  REMARKS_INBOX: 'REMARKS_INBOX',
  EMAIL_TRIAGE: 'EMAIL_TRIAGE',
  ROSTER: 'ROSTER',
};
